import axios from 'axios'

const state = {
    checkupsBuilding: [],
    checkupsProperty: [],
    checkupById: {}, //Одна проверка по id
    checkups: []
};

const getters = {
    checkupsBuilding: state => {
        return state.checkupsBuilding
    },
    checkupsProperty: state => {
        return state.checkupsProperty
    },
    checkupById: state => {
        return state.checkupById
    },
    checkups: state => {
        return state.checkups
    }
};

const mutations = {
    checkupsBuilding: (state, payload) => {
        return state.checkupsBuilding = payload
    },
    checkupsProperty: (state, payload) => {
        return state.checkupsProperty = payload
    },
    checkupById: (state, payload) => {
        return state.checkupById = payload
    },
    setCheckups: (state, payload) => {
        return state.checkups = payload
    },
};

const actions = {
//GET
    checkupsBuildingGet({commit}, id) {
    //Получение и хранение данных о проверках дома
        return axios({
                method: 'GET',
                url: 'checkup/building',
                params: {
                    pg: 0, 
                    batch: 30,
                    buildingId: id,
                    order: "DESC"
                }
            })
            .then(response => {
                if (response) {
                    const checkups = response.data.data                 
                    commit('checkupsBuilding', checkups)
                }
            })
            .catch(err => {
                console.error('Ошибка загрузки данных о проверках здания: ', err)
            })
    },
    checkupsPropertyGet({commit}, id) {
    //Получение и хранение данных о проверках помещения
        return axios({
                method: 'GET',
                url: 'checkup/property',
                params: {
                    pg: 0, 
                    batch: 30,
                    propertyId: id
                }
            })
            .then(response => {
                if (response) {
                    const checkups = response.data.data               
                    commit('checkupsProperty', checkups)
                }
            })
            .catch(err => {
                console.error('Ошибка загрузки данных о проверках помещения: ', err)
            })
    },
    checkupsGetId({commit}, id) {
    //Получение и хранение данных о проверке по id
        return axios({
            method: 'GET',
            url: 'checkup/' + id
        })
        .then(response => {
            commit('checkupById', response.data.data)
        })
        .catch(err => {
            console.error('Ошибка получения проверки: ', err)
        })
    },
    async getAllCheckups({commit}, payload) {
        try {
            const response = await axios({
                method: 'GET',
                url: 'checkup',
                params: {
                    pg: payload.pg,
                    batch: payload.batch ? payload.batch : 25,
                    status: payload.status ? payload.status : null,
                    actnumber: payload.actnumber ? payload.actnumber : null,
                }
            })

            commit('setCheckups', response.data.data)
        } catch(e) {
            console.error(e)
        }
    }
//POST
};

export default {
    state,
    getters,
    mutations,
    actions
}